import { render } from "./RouteSelector.vue?vue&type=template&id=df065cb6"
import script from "./RouteSelector.vue?vue&type=script&lang=js"
export * from "./RouteSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__